<div
  id="app-wrapper"
  role="main"
  [ngClass]="{ 'welcome-gradient': !showBreadcrumb || showGradient }"
>
  <app-loading-spinner></app-loading-spinner>
  @if (showBreadcrumb && (eventDispatcher.showHeaders$ | async)) {
    <ds-breadcrumb></ds-breadcrumb>
  }
  <router-outlet></router-outlet>
</div>
@if (eventDispatcher.showHeaders$ | async) {
  <ds-footer
    [chatEnabled]="chatEnabled$ | async"
    [partnerFooterLogo]="partnerFooterLogo$ | async"
    [lastLogin]="lastLogin$ | async"
    id="footer"
  ></ds-footer>
  <!-- footer component -->
}
